import {
	AfterContentChecked,
	AfterViewChecked,
	Directive,
	ElementRef,
	HostListener,
	NgModule,
	OnInit,
	Renderer2
} from '@angular/core';

@Directive({
	selector: '[tmhnaPortalTextAreaAutoSize]'
})
export class TextAreaAutoSizeDirective
implements OnInit, AfterViewChecked, AfterContentChecked
{
	constructor(private readonly elementRef: ElementRef, private readonly renderer: Renderer2) {}

  @HostListener('ngModelChange', ['$event'])
	ngModelChange() 
	{
		this.resizeTextArea();
	}

  @HostListener('window:resize', ['$event'])
  windowResize() 
  {
  	this.resizeTextArea();
  }

  ngOnInit() 
  {
  	if (this.elementRef.nativeElement.scrollHeight) 
  	{
  		setTimeout(() => this.resizeTextArea());
  	}
  }

  ngAfterViewChecked(): void 
  {
  	this.resizeTextArea();
  }

  ngAfterContentChecked(): void 
  {
  	this.resizeTextArea();
  }

  resizeTextArea() 
  {
  	this.renderer.setStyle(this.elementRef.nativeElement, 'height', '0');
  	this.renderer.setStyle(
  		this.elementRef.nativeElement,
  		'height',
  		this.elementRef.nativeElement.scrollHeight + 4 + 'px'
  	);
  }
}

@NgModule({
	declarations: [TextAreaAutoSizeDirective],
	exports: [TextAreaAutoSizeDirective]
})
  
export class TextAreaAutoSizeDirectiveModule {}
